import { Box, ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import { formatDate } from "date-fns";
import ReactGA from 'react-ga4';
import { useNavigate } from "react-router";
import BetaBadge from "src/components/BetaBadge.component";
import ServiceEndNotice from "src/components/ServiceEndNotice.component";
import { SCREEN_NAMES } from "src/constants/screenNames";
import { endOnForSpan } from "src/pages/LongHaul/spanDays";

interface LinkMenuItemProps {
  path: string;
  selectedDate: Date | null;
  primaryText: string;
  secondaryText: string;
  icon: React.ReactNode;
  /** ベータ版機能であることを示すバッジを primaryText の右側に表示する */
  beta?: boolean;
  /** 提供終了を予告する画面。注意アイコンとツールチップを出す */
  endNotice?: boolean;
  /**
   * 開く日数（両端を含む）。既定の 1 は開始日＝終了日。
   * 長距離配車のように既定のレンジが複数日ある画面だけ指定する。
   */
  rangeDays?: number;
};

export const LinkMenuItem = ({
  path,
  selectedDate,
  primaryText,
  secondaryText,
  icon,
  beta = false,
  endNotice = false,
  rangeDays = 1,
}: LinkMenuItemProps) => {
  const navigate = useNavigate();

  const handleDateMenuItemClick = (path: string) => {
    const date = formatDate(selectedDate || new Date(), 'yyyy-MM-dd');
    ReactGA.event('click', { screen_name: SCREEN_NAMES.DASHBOARD, button_name: 'date', label: date });

    // 終了日の求め方は長距離配車のツールバー（1日/3日/週（7日））と同じ規則に寄せる。
    // Why not 自前で日を足す: 両端を含む数え方（7 日表示 = 開始日 + 6 日）を 2 か所で
    // 持つとずれる。rangeDays が既定の 1 なら開始日と同じ日付が返る
    const endDate = endOnForSpan(date, rangeDays);

    console.log(`Navigate to: /${path}/${date}/${endDate}`);
    void navigate(`/${path}/${date}/${endDate}`);
  };

  const primary = beta ? (
    <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center' }}>
      {primaryText}
      <BetaBadge />
    </Box>
  ) : primaryText;

  const item = (
    <MenuItem onClick={() => handleDateMenuItemClick(path)}>
      <ListItemIcon>
        {icon}
      </ListItemIcon>
      <ListItemText
        primary={primary}
        secondary={secondaryText}
      />
    </MenuItem>
  );

  return endNotice ? <ServiceEndNotice>{item}</ServiceEndNotice> : item;
};
